import { API_URL, createHeaders } from './base'

export interface WorkspacePayload {
  name: string
  path: string
  description?: string | null
}

export interface WorkspaceResponse {
  id: number
  name: string
  path: string
  description: string | null
  is_active: boolean
  created_at: string
  updated_at: string
}

export async function fetchWorkspaces(): Promise<WorkspaceResponse[]> {
  const response = await fetch(`${API_URL}/workspaces`, { headers: createHeaders() })
  if (!response.ok) throw new Error('Failed to fetch workspaces')
  return response.json()
}

export async function fetchActiveWorkspace(): Promise<WorkspaceResponse | null> {
  const response = await fetch(`${API_URL}/workspaces/active`, { headers: createHeaders() })
  if (!response.ok) throw new Error('Failed to fetch active workspace')
  return response.json()
}

export async function createWorkspaceApi(data: WorkspacePayload): Promise<WorkspaceResponse> {
  const response = await fetch(`${API_URL}/workspaces`, {
    method: 'POST',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: 'Failed to create workspace' }))
    throw new Error(err.detail || 'Failed to create workspace')
  }
  return response.json()
}

export async function updateWorkspaceApi(id: number, data: Partial<WorkspacePayload>): Promise<WorkspaceResponse> {
  const response = await fetch(`${API_URL}/workspaces/${id}`, {
    method: 'PUT',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: 'Failed to update workspace' }))
    throw new Error(err.detail || 'Failed to update workspace')
  }
  return response.json()
}

export async function activateWorkspaceApi(id: number): Promise<WorkspaceResponse> {
  const response = await fetch(`${API_URL}/workspaces/${id}/activate`, {
    method: 'PUT',
    headers: createHeaders(),
  })
  if (!response.ok) throw new Error('Failed to activate workspace')
  return response.json()
}

export async function deleteWorkspaceApi(id: number): Promise<void> {
  const response = await fetch(`${API_URL}/workspaces/${id}`, {
    method: 'DELETE',
    headers: createHeaders(),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: 'Failed to delete workspace' }))
    throw new Error(err.detail || 'Failed to delete workspace')
  }
}

export async function updateWorkspaceGoals(workspaceId: number, goals: string[]): Promise<WorkspaceResponse> {
  const response = await fetch(`${API_URL}/workspaces/${workspaceId}/goals`, {
    method: 'PUT',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ goals }),
  })
  if (!response.ok) throw new Error('Failed to update workspace goals')
  return response.json()
}
